import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/messages";

class MessageService {
  createMessage = async ({ email, fullName, subject, message }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, {
        email,
        fullName,
        message,
        subject,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while creating message, status:" + err.code
      );
    }
  };
}

const messageService = new MessageService();

export default messageService;
